import { createSlice } from "@reduxjs/toolkit";
import { dayOfWeek } from "../../utils/date";

const initialState = {
    errorMessage:'',
    status:'initial',
    selectedTime:dayOfWeek[new Date().getDay()],
    timings:[],
};
const profileReducer = createSlice({
    name: 'profile',
    initialState,
    reducers:{
        setResetprofile: (state)=>{
            state.errorMessage = '';
            state.status = 'initial';
            state.selectedTime = dayOfWeek[new Date().getDay()];
        },
        setselectedTime: (state,action)=>{
            state.selectedTime = action.payload;
        },
        setLoadingTimings: (state)=>{
            state.errorMessage = '';
            state.status = 'loading';
        },
        setSuccessTimings: (state,action)=>{
            state.errorMessage = '';
            state.status = 'success';
            state.timings=action.payload
        },
        setErrorTimings: (state,action)=>{
            state.errorMessage = action.payload;
            state.status = 'error';
        },
        setTimings: (state,action)=>{
            state.timings=action.payload;
        },
        setTimingsValue: (state,action)=>{
            state.timings[0][action.payload.key]=action.payload.value;
        },
    },
});

export default profileReducer.reducer;
export const {setResetprofile,setselectedTime,setTimings,setErrorTimings,setLoadingTimings,setSuccessTimings,setTimingsValue} = profileReducer.actions;